import { render, staticRenderFns } from "./ProductPage.vue?vue&type=template&id=87ee1072&scoped=true"
import script from "./ProductPage.vue?vue&type=script&lang=ts"
export * from "./ProductPage.vue?vue&type=script&lang=ts"
import style0 from "./ProductPage.vue?vue&type=style&index=0&id=87ee1072&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ee1072",
  null
  
)

export default component.exports